export default "__VITE_ASSET__835fa0cd__"